import { MediaComponent } from "@common/components/Media/component";
import { type AspectRatio } from "@common/controls/AspectRatioContainer/lib";
import { type Media } from "@common/declarations";
import React from "react";

type Props = {
  aspectRatio?: AspectRatio;
  doesNotRequireVideoApp?: boolean;
  media: Media.Item | null;
  type: "Video" | "Audio";
};

export default (props: Props) => {
  if (!props.media) return null;

  return (
    <MediaComponent
      allowFullScreen
      doesNotRequireVideoApp={props.doesNotRequireVideoApp}
      shouldTrackVideo
      sourceId={props.media.sourceId}
      sourceKey={props.media.mediaSourceKey}
      typeKey={props.media.mediaTypeKey}
    />
  );
};
